/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocsCatalogControllerCatalogQueryResponse } from "../../models/documentsController/DocsCatalogControllerCatalog";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { docsCatalogControllerCatalog } from "../../clients/documentsService/docsCatalogControllerCatalog";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const docsCatalogControllerCatalogQueryKey = () => [{
  url: '/api/v1/documents/docs/catalog'
}] as const;
export type DocsCatalogControllerCatalogQueryKey = ReturnType<typeof docsCatalogControllerCatalogQueryKey>;
export function docsCatalogControllerCatalogQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = docsCatalogControllerCatalogQueryKey();
  return queryOptions<DocsCatalogControllerCatalogQueryResponse, ResponseErrorConfig<Error>, DocsCatalogControllerCatalogQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return docsCatalogControllerCatalog(config);
    }
  });
}

/**
 * @summary List the documents resource’s markdown docs
 * {@link /api/v1/documents/docs/catalog}
 */
export function useDocsCatalogControllerCatalog<TData = DocsCatalogControllerCatalogQueryResponse, TQueryData = DocsCatalogControllerCatalogQueryResponse, TQueryKey extends QueryKey = DocsCatalogControllerCatalogQueryKey>(options: {
  query?: Partial<QueryObserverOptions<DocsCatalogControllerCatalogQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? docsCatalogControllerCatalogQueryKey();
  const query = useQuery({
    ...docsCatalogControllerCatalogQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}